import { Play, Headphones, ArrowUpRight } from "lucide-react";
import { useReader } from "./ReaderContext";

const ICONS = { watch: Play, listen: Headphones, visit: ArrowUpRight };

export const Cta = ({ cta, pageN, i }) => {
  const Icon = ICONS[cta.kind] || ArrowUpRight;
  const { openMedia } = useReader();
  if (cta.media?.type && openMedia) {
    return (
      <button type="button" className="mag-btn" onClick={() => openMedia(cta)} data-testid={`page-${pageN}-cta-${i}`}>
        <Icon size={10} strokeWidth={2.5} /> {cta.label}
      </button>
    );
  }
  return (
    <a className="mag-btn" href={cta.url} target="_blank" rel="noopener noreferrer" data-testid={`page-${pageN}-cta-${i}`}>
      <Icon size={10} strokeWidth={2.5} /> {cta.label}
    </a>
  );
};

export const Ctas = ({ page, className = "" }) =>
  page.ctas?.length ? (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {page.ctas.map((c, i) => <Cta key={i} cta={c} pageN={page.n} i={i} />)}
    </div>
  ) : null;

export const Credits = ({ page, className = "" }) =>
  page.credits?.length ? (
    <div className={`mag-credit ${className}`}>
      {page.credits.map((c, i) => <div key={i}>{c}</div>)}
    </div>
  ) : null;

export const Note = ({ page, className = "" }) => (page.note ? <div className={`mag-note ${className}`}>{page.note}</div> : null);

export const Shell = ({ page, children, dark, className = "", hideHeader = false }) => {
  const { edition } = useReader();
  const sectionName = edition?.sections?.[page.section] || page.section;
  return (
    <article className={`mag-page ${dark ? "mag-dark" : ""} ${className}`} data-testid={`mag-page-${page.n}`} lang={edition?.lang} dir={edition?.dir || "ltr"}>
      {!hideHeader && (
        <header className="absolute top-7 left-11 right-11 flex items-center gap-3">
          <span className="mag-kicker font-semibold">ROOTS</span>
          <span className="silver-rule-solid flex-1" style={{ opacity: dark ? 0.35 : 1 }} />
          <span className="mag-kicker" style={{ color: dark ? "var(--platinum)" : "var(--bordeaux)" }}>{sectionName}</span>
        </header>
      )}
      {children}
      <footer className="mag-folio">
        <span>{edition?.number || "Edition 001"} · {edition?.title}</span>
        <span data-testid={`page-${page.n}-folio`}>{String(page.n).padStart(2, "0")}</span>
      </footer>
    </article>
  );
};
